import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-39d42e36"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ub ub-ac ub-pb fw h48px bgfff pdl16 pdr16 dayin" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("打印")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("关闭")
const _hoisted_4 = {
  class: "ub ub-ver fw print-div",
  id: "flow-print-table"
}
const _hoisted_5 = { class: "ub ub-ver ub-ac ub-pc fw bgfff header" }
const _hoisted_6 = { class: "ub ub-ac ub-ps fw nav pdl16 pdr16" }
const _hoisted_7 = { class: "ub ub-ac ub-pc title" }
const _hoisted_8 = { class: "ub ub-ac ub-pc sub-title" }

export function render(_ctx, _cache) {
  const _component_a_checkbox_group = _resolveComponent("a-checkbox-group")
  const _component_a_button = _resolveComponent("a-button")
  const _component_a_space = _resolveComponent("a-space")
  const _component_a_descriptions_item = _resolveComponent("a-descriptions-item")
  const _component_a_descriptions = _resolveComponent("a-descriptions")
  const _component_attachment = _resolveComponent("attachment")
  const _component_approval_flow_log_table = _resolveComponent("approval-flow-log-table")
  const _component_print_item = _resolveComponent("print-item")
  const _directive_print = _resolveDirective("print")

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["ub ub-ver fw flow-print", {'in-iframe':_ctx.isIframe}])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", null, [
        _renderSlot(_ctx.$slots, "tab", {}, undefined, true),
        _createVNode(_component_a_checkbox_group, {
          class: "ub ub-f1",
          value: _ctx.selectedCheckbox,
          "onUpdate:value": _cache[0] || (_cache[0] = $event => ((_ctx.selectedCheckbox) = $event)),
          name: "checkboxgroup",
          options: _ctx.checkboxes
        }, null, 8, ["value", "options"])
      ]),
      _createVNode(_component_a_space, null, {
        default: _withCtx(() => [
          _withDirectives((_openBlock(), _createBlock(_component_a_button, { type: "primary" }, {
            default: _withCtx(() => [
              _hoisted_2
            ]),
            _: 1
          })), [
            [_directive_print, _ctx.printConfig]
          ]),
          _createVNode(_component_a_button, { onClick: _ctx.cancel }, {
            default: _withCtx(() => [
              _hoisted_3
            ]),
            _: 1
          }, 8, ["onClick"])
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_4, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.loopSection, (item, index) => {
        return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
          (item.show&&item.value==='header')
            ? _renderSlot(_ctx.$slots, "header", {
                key: 0,
                record: _ctx.basicInfo
              }, () => [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _renderSlot(_ctx.$slots, "nav", {}, undefined, true)
                  ]),
                  _createElementVNode("div", _hoisted_7, [
                    _renderSlot(_ctx.$slots, "title", {}, () => [
                      _createTextVNode(_toDisplayString(_ctx.basicInfo?.name??_ctx.basicInfo?.projectName), 1)
                    ], true)
                  ]),
                  _createElementVNode("div", _hoisted_8, [
                    _renderSlot(_ctx.$slots, "subTitle", {}, () => [
                      _createVNode(_component_a_descriptions, {
                        column: 2,
                        style: {"max-width":"1100px"}
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_descriptions_item, { label: _ctx.bizNoLabelName }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.basicInfo?.bizNo), 1)
                            ]),
                            _: 1
                          }, 8, ["label"]),
                          (!_ctx.basicInfo?.projectStatusName&&_ctx.validStatusLabelName?.length>0)
                            ? (_openBlock(), _createBlock(_component_a_descriptions_item, {
                                key: 0,
                                label: _ctx.validStatusLabelName,
                                labelStyle: {
                    width:_ctx.labelWidth+'px',
                    textAlign:'right',
                    display:'block'
                  }
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.basicInfo?.statusName??_ctx.basicInfo?.validStatusName), 1)
                                ]),
                                _: 1
                              }, 8, ["label", "labelStyle"]))
                            : _createCommentVNode("", true),
                          (_ctx.basicInfo?.projectStatusName)
                            ? (_openBlock(), _createBlock(_component_a_descriptions_item, {
                                key: 1,
                                label: '项目状态',
                                labelStyle: {
                  width:_ctx.labelWidth+'px',
                  textAlign:'right',
                  display:'block'
                }
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.basicInfo?.projectStatusName??_ctx.basicInfo?.statusName), 1)
                                ]),
                                _: 1
                              }, 8, ["labelStyle"]))
                            : _createCommentVNode("", true),
                          _createVNode(_component_a_descriptions_item, { label: "审批状态" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.basicInfo?.flowStatusName), 1)
                            ]),
                            _: 1
                          }),
                          (_ctx.contractStatusLabelNameKey?.length>0)
                            ? (_openBlock(), _createBlock(_component_a_descriptions_item, {
                                key: 2,
                                label: "合同状态",
                                labelStyle: {
                  width:_ctx.labelWidth+'px',
                  textAlign:'right',
                  display:'block'
                }
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.contractStatusLabelNameKey), 1)
                                ]),
                                _: 1
                              }, 8, ["labelStyle"]))
                            : _createCommentVNode("", true),
                          _createVNode(_component_a_descriptions_item, { label: "打印日期" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.nowStr), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ], true)
                  ])
                ])
              ], true)
            : _createCommentVNode("", true),
          (item.show&&item.value==='tab')
            ? _renderSlot(_ctx.$slots, "tabHeader", {
                key: 1,
                record: _ctx.basicInfo
              }, undefined, true)
            : _createCommentVNode("", true),
          (item.show && item.value !=='header'&& item.value !=='tab' && item.value !== 'qrcode')
            ? (_openBlock(), _createBlock(_component_print_item, {
                key: 2,
                label: item.label,
                class: _normalizeClass([index==1?'first-print-item':'',index==_ctx.loopSection.length-1?'last-print-item':''])
              }, {
                header: _withCtx(() => [
                  _createTextVNode(_toDisplayString(item.label), 1)
                ]),
                body: _withCtx(() => [
                  _renderSlot(_ctx.$slots, item.value, { record: _ctx.basicInfo }, () => [
                    (item.value === 'attach')
                      ? (_openBlock(), _createBlock(_component_attachment, {
                          key: 0,
                          value: _ctx.attachList,
                          "onUpdate:value": _cache[1] || (_cache[1] = $event => ((_ctx.attachList) = $event)),
                          "biz-id": _ctx.id,
                          "biz-type": _ctx.attachBizType
                        }, null, 8, ["value", "biz-id", "biz-type"]))
                      : _createCommentVNode("", true),
                    (item.value==='flow')
                      ? (_openBlock(), _createBlock(_component_approval_flow_log_table, {
                          key: 1,
                          "biz-id": _ctx.id,
                          "biz-type": _ctx.flowBizType
                        }, null, 8, ["biz-id", "biz-type"]))
                      : _createCommentVNode("", true)
                  ], true)
                ]),
                _: 2
              }, 1032, ["label", "class"]))
            : _createCommentVNode("", true)
        ], 64))
      }), 128))
    ])
  ], 2))
}